import { Component, Prop, Vue } from 'vue-property-decorator'
import SectionInfoColType from '@/modules/globalLocatorModule/sections/info/col-types/section-info-col-type.vue'
import { Nullable } from '@/shared/types/app.types'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'

@Component({
    components: {
        SectionInfoColType
    }
})
export default class SectionInfoColTypePersonnel extends Vue {
    @Prop(String) readonly label!: string
    @Prop(Object) readonly personnel!: CommonPersonnelResponse
    @Prop(String) readonly colClass!: string

    get personnelId(): Nullable<number> {
        return this.personnel?.id
    }
}
